import PropertiesGridEmptyState from '@/components/PropertiesGridEmptyState/PropertiesGridEmptyState';
import PropertyCard from '@/components/PropertyCard/PropertyCard';
import type { Unit } from '@/domain/units';
import { useMemo, type FC } from 'react';

interface Props {
  units: Unit[] | undefined;
}

const PropertiesGrid: FC<Props> = ({ units }) => {
  const showFeatures = useMemo(
    () => units?.sort((a, b) => a.id - b.id).some((unit) => !!unit.amenityNames?.length),
    [units],
  );

  if (!units?.length) {
    return <PropertiesGridEmptyState />;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {units.map((unit) => (
        <PropertyCard
          key={`property-card-${unit.id}`}
          property={unit.property}
          unit={unit}
          showFeatures={showFeatures}
          showApplyButtons
        />
      ))}
    </div>
  );
};

export default PropertiesGrid;
